import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../context/UserContext';

export default function PrivateRoute({ children }) {
  const { user, loading } = useCurrentUser();
  const navigate = useNavigate();

  if (loading) return null;

  // return user ? (
  //   <Route {...rest} element={children} />
  // ) : (
  //   <Navigate to={{ pathname: '/login', state: { from: navigate.location } }} />
  // );

  if (!user) {
    return <Navigate to={{ pathname: '/login', state: { from: navigate.location } }} />
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node,
};
